import ClubSalesListConfig from '../dto/ClubSalesListConfig';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubSalesListConfigRepository {

    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sales-list/config`)
                .then(response =>
                    resolve(ClubSalesListConfig.fromData(response.data.data))
                )
                .catch(error => reject(Error.fromResponse(error.response)))
        });
    }

    static update(clubId, clubSalesListConfig) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/sales-list/config`, clubSalesListConfig.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
